"use strict";
import React from "react";
import classNames from "classnames";
import { Link } from "react-router";
import { Range } from "immutable";
function currentPage(props) {
  return Math.min(
    ...[parseInt(props.location.query.page || "1"), props.numberOfPages]
  );
}
function pageWindow(props) {
  var startPage = currentPage(props);
  var lastPage = props.numberOfPages;
  var windowSize = props.windowSize || 15;
  if (lastPage <= windowSize) {
    return Range(1, lastPage + 1);
  }
  var start = startPage - Math.floor(windowSize / 2);
  if (start < 1) {
    start = 1;
  }
  var stop = start + windowSize;
  if (stop > lastPage) {
    stop = lastPage + 1;
    start = Math.max(...[1, stop - windowSize]);
  }
  return Range(start, stop);
}
function showPage(props, page) {
  return /* @__PURE__ */ React.createElement(
    "li",
    {
      className: classNames({ current: currentPage(props) === page }),
      key: "page-link-" + page
    },
    /* @__PURE__ */ React.createElement(
      Link,
      {
        to: props.location.pathname,
        query: Object.assign({}, props.location.query, { page })
      },
      page
    )
  );
}
function Paginator(props) {
  var page = currentPage(props);
  var prevClasses = classNames({ arrow: true, unavailable: page <= 1 });
  var nextClasses = classNames({
    arrow: true,
    unavailable: page === props.numberOfPages
  });
  return /* @__PURE__ */ React.createElement("ul", { "data-component": "Paginator", className: "pagination" }, /* @__PURE__ */ React.createElement("li", { className: prevClasses }, /* @__PURE__ */ React.createElement(
    Link,
    {
      to: props.location.pathname,
      query: Object.assign({}, props.location.query, {
        page: page - 1
      })
    },
    "\xAB"
  )), pageWindow(props).map((page2) => showPage(props, page2)), /* @__PURE__ */ React.createElement("li", { className: nextClasses }, /* @__PURE__ */ React.createElement(
    Link,
    {
      to: props.location.pathname,
      query: Object.assign({}, props.location.query, {
        page: page + 1
      })
    },
    "\xBB"
  )));
}
export default Paginator;
